.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-4);
  margin-top: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-2);
  background: var(--tuna-color-surface);
}

.header {
  margin: 0;
  font-weight: 700;
  font-size: var(--tuna-font-size-2);
}

.correct {
  color: var(--tuna-color-success);
}

.incorrect {
  color: var(--tuna-color-error);
}

.body {
  margin: 0;
  font-size: var(--tuna-font-size-1);
  line-height: 1.5;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--tuna-spacing-2);
}

.nextButton {
  font-weight: 600;
}
